import { render, staticRenderFns } from "./platform_ticket.vue?vue&type=template&id=815d3b06&scoped=true"
import script from "./platform_ticket.vue?vue&type=script&lang=js"
export * from "./platform_ticket.vue?vue&type=script&lang=js"
import style0 from "./platform_ticket.vue?vue&type=style&index=0&id=815d3b06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815d3b06",
  null
  
)

export default component.exports